// ─── Poids des PLAFONDS dans le pool à la carte ────────────────────
// Les fonctions du catalogue ont leur poids réglé ligne par ligne (cf.
// LigneFonctionForfait) ; les PLAFONDS (jetons, espaces, calendriers…) n'ont
// pas de ligne dédiée ailleurs — ils vivent dans les steppers jetons/espaces
// de la carte de forfait et dans les limites par type de FeuillePlan. Un seul
// endroit pour régler leur poids, plutôt que de le disperser à chaque
// stepper existant.
import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { stylesForm, useUI, useT, poidsDe, Stepper } from '@mop/core';
import { definirPoidsFonction } from './services/admin';

const QUOTAS = [
  { cle: 'gestion', emoji: '⚙️', labelCle: 'admin.jetonsGestion' },
  { cle: 'vue', emoji: '👁', labelCle: 'admin.jetonsVue' },
  { cle: 'espaces', emoji: '🏠', labelCle: 'admin.maxEspaces' },
  { cle: 'calendriers', emoji: '📅', labelCle: 'admin.typeCalendriers' },
  { cle: 'inventaires', emoji: '📦', labelCle: 'admin.typeInventaires' },
  { cle: 'repas', emoji: '🍽️', labelCle: 'admin.typeRepas' },
  { cle: 'comptes', emoji: '💶', labelCle: 'admin.typeComptes' },
];

export default function SectionPoidsQuotas({ cfg, onErreur }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);

  const majPoids = (cle, v) => definirPoidsFonction(cle, v).catch(onErreur);

  return (
    <View style={s.bloc}>
      <Text style={s.titre}>{t('admin.poidsFonction')} — {t('admin.limitesParType')}</Text>
      <Text style={s.aide}>{t('admin.limitesParTypeAide')}</Text>
      {QUOTAS.map(q => {
        const poids = poidsDe(cfg, { key: q.cle });
        return (
          <View key={q.cle} style={s.ligne}>
            <Text style={s.lbl}>{q.emoji} {t(q.labelCle)}</Text>
            <Stepper valeur={poids} onMoins={() => majPoids(q.cle, poids - 1)} onPlus={() => majPoids(q.cle, poids + 1)} />
          </View>
        );
      })}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  ...stylesForm(UI),
  bloc: { backgroundColor: UI.card, borderRadius: 13, borderWidth: 0.5, borderColor: UI.border, padding: 12, marginBottom: 8, gap: 4 },
  titre: { fontSize: 14.5, fontWeight: '800', color: UI.ink },
  aide: { fontSize: 11.5, color: UI.muted, marginBottom: 4 },
  ligne: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
           paddingVertical: 7, borderTopWidth: 0.5, borderTopColor: UI.border },
  lbl: { fontSize: 13, fontWeight: '700', color: UI.ink },
});
